module.exports = __webpack_public_path__ + "static/img/bg_hidden.9ff85e71.png";